// extracted by mini-css-extract-plugin
module.exports = {"nav":"style_nav__3EJAW","left":"style_left__3tWIA","brand":"style_brand__3Ue2f","right":"style_right__3sMPa"};